import { startClientApp } from "./entry-client";
import reportWebVitals from "./reportWebVitals";

startClientApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
